import { readJson, writeJson } from "@/lib/toolkit/storage";

export type RecentScenario = { slug: string; at: number };

const KEY = "wi_recent_scenarios";
const MAX = 8;

/** Local-only history of opened scenarios. No backend, no user data leaves the device. */
export function pushRecentScenario(slug: string) {
  const list = readJson<RecentScenario[]>(KEY, []);
  const next = [{ slug, at: Date.now() }, ...list.filter((r) => r.slug !== slug)].slice(0, MAX);
  writeJson(KEY, next);
}

export function readRecentScenarios(): RecentScenario[] {
  return readJson<RecentScenario[]>(KEY, []).filter((r) => typeof r?.slug === "string");
}

export function clearRecentScenarios() {
  writeJson(KEY, []);
}

export const RECENT_SCENARIOS_KEY = KEY;
